import { motion } from "framer-motion";
import { Star } from "lucide-react";

const TrustpilotBadge = () => {
  return (
    <section className="py-16 bg-card/20">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex flex-col items-center gap-6"
        >
          {/* Trustpilot Logo */}
          <div className="flex items-center gap-2">
            <svg viewBox="0 0 126 31" className="h-8 w-auto" aria-label="Trustpilot">
              <path d="M33.3 12.1h-8.5l-2.6-8.1L19.6 12l-8.5.1 6.9 5-2.6 8.1 6.9-5 6.9 5-2.7-8 6.9-5.1z" fill="hsl(var(--gold))" />
            </svg>
            <span className="font-display text-2xl font-bold text-foreground tracking-tight">Trustpilot</span>
          </div>

          {/* Rating Display */}
          <div className="flex flex-col items-center gap-3">
            <div className="flex items-center gap-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="bg-[#00b67a] p-1 rounded-sm">
                  <Star className="h-5 w-5 fill-white text-white" />
                </div>
              ))}
            </div>
            <p className="text-muted-foreground font-body text-sm">
              TrustScore <span className="font-semibold text-foreground">4.9</span> | <span className="font-semibold text-foreground">12,847</span> reviews
            </p>
          </div>

          {/* Tagline */}
          <p className="text-muted-foreground font-body text-center max-w-md">
            Rated <span className="font-semibold text-foreground">Excellent</span> by thousands of investors worldwide
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustpilotBadge;
